import cn from 'client/utils/cn';

import React, { Component } from 'react';

import './index.css';

import { MenuItemLink, MenuItems, PAGES } from 'client/utils/menu-utils';

const b = cn('menu-section');

interface Props {
    type: 'principles' | 'governance' | 'video';
    items?: MenuItems;
    noBorder?: boolean;
    pageName: string;
}

interface State {
    isMenuOpened: boolean;
}

class MenuSection extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isMenuOpened: false
        };
    }

    toggleMenu = () => {
        this.setState({ isMenuOpened: !this.state.isMenuOpened });
    }

    getItems = (): MenuItems => {
        return PAGES[this.props.type];
    }

    renderAdaptiveContent = (items: MenuItems) => {
        const { pageName } = this.props;
        const pageTitle = items[pageName]?.title;
        const itemsList = { ...items };

        delete itemsList[pageName];

        return (
            <>
                <div className={b('title')}>
                    {pageTitle}
                    <span className={b('arrow')} />
                </div>
                {this.renderItems(itemsList)}
            </>
        );
    }

    renderItems = (items: MenuItems) => {
        const itemNames = Object.keys(items);

        return (
            <div className={b('items')}>
                {itemNames.map(itemName => this.renderMenuLink(items[itemName], itemName))}
            </div>
        );
    }

    renderMenuLink = (itemData: MenuItemLink, pageId: string) => {
        const { title, href } = itemData;

        return (
            <a
                href={href}
                key={pageId}
                className={b('item', { active: pageId === this.props.pageName })}
                >
                { title }
            </a>
        );
    }

    render() {
        let { items } = this.props;

        if (!items) {
            items = this.getItems();
        }

        return (
            <div className={b({ 'no-border': this.props.noBorder })}>
                <div className={b('regular')}>
                    {this.renderItems(items)}
                </div>
                <div
                    className={b('adaptive', { opened: this.state.isMenuOpened })}
                    onClick={this.toggleMenu}
                    >
                    {this.renderAdaptiveContent(items)}
                </div>
            </div>
        );
    }
}

export default MenuSection;
